import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useShowErrorsPopup } from '@/hooks'
import { fragments } from '@/hooks/fragments'
import { Query, QueryGetPrivateSaleByIdArgs } from '@/schemaTypes'

const GET_PRIVATE_SALE_BY_ID = gql`
  query getPrivateSaleById($privateSaleId: ObjectId!) {
    getPrivateSaleById(privateSaleId: $privateSaleId) {
      _id
      createdAt
      creationType
      privateSaleDate
      dealId
      itemId
      bookingNumber
      carTitle
      customerFullName
      status
      dealFinalBalance
      privateSaleTransactions {
        ...PrivateSaleTransactionFragment
      }
    }
  }
  ${fragments.privateSaleTransaction}
`

type TData = { getPrivateSaleById: Query['getPrivateSaleById'] }
type TVariables = QueryGetPrivateSaleByIdArgs

export function useGetPrivateSaleById(
  opts: QueryHookOptions<TData, TVariables> = {},
) {
  const queryResult = useQuery<TData, TVariables>(GET_PRIVATE_SALE_BY_ID, {
    fetchPolicy: 'network-only',
    ...opts,
  })

  useShowErrorsPopup(queryResult.error)

  return { queryResult, privateSale: queryResult.data?.getPrivateSaleById }
}
